import { createContext, useContext } from "react";
import { sv } from "./languages/sv";
import { en } from "./languages/en";
import type { Language, PdfStrings } from "./types";

type LocalizationContextProps = {
  children: React.ReactNode;
  language: Language;
};

type LocalizationContextValue = {
  language: Language;
  strings: PdfStrings;
};

const strings: Record<Language, PdfStrings> = { sv, en };

const LocalizationContext = createContext<LocalizationContextValue | undefined>(undefined);

/**
 * Hook to access the localization context.
 * Returns the current language and the full strings object.
 */
const useLocalization = () => {
  const context = useContext(LocalizationContext);
  if (!context) {
    throw new Error("useLocalization must be used within a LocalizationProvider");
  }
  return context;
};

const LocalizationProvider: React.FC<LocalizationContextProps> = ({ children, language }) => {
  return (
    <LocalizationContext.Provider
      value={{
        language,
        strings: strings[language],
      }}
    >
      {children}
    </LocalizationContext.Provider>
  );
};

export { LocalizationProvider as default, useLocalization };
